module.exports = __webpack_public_path__ + "static/media/salonpic.285e2fec.png";